'use strict';
//mockplusjszip
var _ = require('underscore');
var toString = Object.prototype.toString;
var dataHelper = require('./dataHelper');
var Reconstruction = require('./ReconstructionHelper.js');
var pageHelper = require('./pageHelper');
var appTypes = require('../types/appTypes');
var toolHelper = require('./tool');
var runtimeHelper = require('./runtimeHelper');
var urlHelper = require('./urlHelper');
var request = require('superagent');
var version = new Date().getTime().toString(36);
var apiHelper = require('./apiHelper');

var zip = null;
var currentProject = null;
var currentPath = 'app'; // 非 dev 时使用

// 暂时禁用缓存
var pagesCache = {};
var masterCache = {};
var imageCache = {};

var firstPageCache = null;

/**
 * 配置数组节点, 出现这些节点时, 即使没有同名兄弟节点,也会放到数组中
 * @type {string[]}
 */
var arrayTags = ['page', 'module', 'state', 'link', 'control', 'event', 'behaviour', 'target', 'command', 'param', 'entry'];

/**
 * 判断是否是数组
 * @param obj
 * @returns {boolean}
 */
function isArray(obj) {
  return toString.call(obj) === '[object Array]';
}

/**
 * 将文本转换为 DOM
 * @param str
 * @returns {*}
 */
function parseTODOM(str) {
  var xmlDoc;
  var parser;
  if (window.DOMParser) {
    parser = new DOMParser();
    xmlDoc = parser.parseFromString(str, 'text/xml');
  } else if (window.ActiveXObject) {
    xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
    xmlDoc.async = false;
    xmlDoc.loadXML(str);
  } else {
    throw new Error('cannot parse xml');
  }
  return xmlDoc;
}

/**
 * 判断是否是文本节点
 * 规则:
 * 1. 仅包含一个子节点
 * 2. 子节点的节点名为 `#text`
 * @param node
 * @returns {boolean}
 */
function isTextNode(node) {
  return node.childNodes.length === 1 && node.childNodes[0].nodeName === '#text';
}

/**
 * 获取文本节点的值
 * @param obj
 * @returns {string}
 */
function getTextNode(obj) {
  return obj.childNodes[0].nodeValue;
}

function parseNode(xmlNode, result) {
  var length;
  var i;
  var jsonNode;
  var existing;
  var attribute;

  if (isTextNode(xmlNode)) {
    result[xmlNode.nodeName] = dataHelper.convertValue(xmlNode.nodeName, getTextNode(xmlNode));
    return;
  }

  if (xmlNode.nodeName === '#text' && xmlNode.nodeValue.trim() === '') { // ignore empty text node
    return;
  }
  jsonNode = {};
  if (xmlNode.nodeName === 'page' || xmlNode.nodeName === 'module') {
    jsonNode.isModule = xmlNode.nodeName === 'module';
    if (!result._pages) {
      result._pages = [];
    }
    result._pages.push(jsonNode);
  } else {
    existing = result[xmlNode.nodeName];
    if (existing) {
      if (!isArray(existing)) {
        result[xmlNode.nodeName] = [existing, jsonNode];
      } else {
        result[xmlNode.nodeName].push(jsonNode);
      }
    } else {
      if (arrayTags && arrayTags.indexOf(xmlNode.nodeName) != -1) {
        result[xmlNode.nodeName] = [jsonNode];
      } else {
        result[xmlNode.nodeName] = jsonNode;
      }
    }
  }

  if (xmlNode.attributes) {
    length = xmlNode.attributes.length;
    for (i = 0; i < length; i++) {
      attribute = xmlNode.attributes[i];
      if (xmlNode.nodeName === 'page' && attribute.nodeName === 'isdeleted' && attribute.nodeValue === 'True') {
        result._pages.pop(); // 移除最后添加的那个页面
        return
      }
      jsonNode[attribute.nodeName] = dataHelper.convertValue(attribute.nodeName, attribute.nodeValue);
    }
  }

  if (jsonNode.isfolder) {
    jsonNode.isModule = true;
  }

  length = xmlNode.childNodes.length;
  for (i = 0; i < length; i++) {
    parseNode(xmlNode.childNodes[i], jsonNode);
  }
}

function parseXMLToObject(str) {
  var dom = parseTODOM(str);
  var result = {};
  if (dom.childNodes.length) {
    parseNode(dom.childNodes[0], result);
  }
  return result;
}

/**
 * 递归替换组件controlID
 * @param comArray
 * @param idMap
 */
function doResetNewComID(comArray, idMap) {
  var i;
  var newComID;
  var com;
  var l = 0;
  if (comArray) {
    l = comArray.length;
  }
  for (i = 0; i < l; i++) {
    com = comArray[i];
    if (com.items !== undefined) {
      doResetNewComID(com.items, idMap);
    }

    // 重置组件ID号
    newComID = toolHelper.newGuid();

    idMap[comArray[i].controlID] = newComID;
    comArray[i].controlID = newComID;
  }
}

/**
 * 递归替换组件交互中targetID号
 * @param comArray
 * @param idMap
 */
function doResetNewTargetID(comArray, idMap) {
  var i;
  var com;
  var interactiveData;
  var entry;
  var entrys;
  var iEntry;
  var events;
  var iEvent;
  var event;
  var iBehaviour;
  var behaviour;
  var iTarget;
  var target;
  var oldTargetID;
  var newTargetID;
  if (comArray) {
    for (i = 0; i < comArray.length; i++) {
      com = comArray[i];
      if (com.items) {
        doResetNewTargetID(com.items, idMap);
      }

      interactiveData = com.interactiveData;
      if (!interactiveData)
        continue;

      entrys = interactiveData.entry;
      if (entrys) {
        for (iEntry = 0; iEntry < entrys.length; iEntry++) {
          entry = entrys[iEntry];
          if (entry.events && entry.events.event) {

            for (iEvent = 0; iEvent < entry.events.event.length; iEvent++) {
              event = entry.events.event[iEvent];

              for (iBehaviour = 0; iBehaviour < event.behaviour.length; iBehaviour++) {
                behaviour = event.behaviour[iBehaviour];

                for (iTarget = 0; iTarget < behaviour.target.length; iTarget++) {
                  target = behaviour.target[iTarget];

                  oldTargetID = target.targetID;
                  newTargetID = idMap[oldTargetID];
                  if (newTargetID) {
                    target.targetID = newTargetID;
                  }
                } // for (iTarget = 0)
              } // for(iBehaviour = 0)
            } // for (iEvent = 0;)
          }
        } // for (iEntry = 0)

      }

    }
  }
}

/**
 * 替换组件数组中的所有组件ID号，包括交互数据中targetID
 * @param comArray
 */
function resetNewComID(comArray) {
  var idMap = {};
  if (comArray) {
    doResetNewComID(comArray, idMap);

    // 替换组件内交互组件ID号。
    doResetNewTargetID(comArray, idMap);
  }
}

/**
 * 获取母版数据
 * @param masterID
 * @param cb
 * @returns {*}
 */
function getMaster(masterID, cb) {
  var master;
  // if (masterCache[masterID]) { // 优先使用 cache
  //   return cb(null, masterCache[masterID]);
  // }
  if (runtimeHelper.isLoadFromZip()) {
    try {
      master = parseXMLToObject(zip.files['Master/' + masterID + '.mbx'].asText().trim());
      masterCache[masterID] = master;
      cb(null, master);
    } catch (e) {
      cb(e);
    }
  } else if (runtimeHelper.isLoadFromEnterprise()) {
    apiHelper.loadResource('Master/' + masterID + runtimeHelper.getMBXExtension() + '?v=' + version, function (err, text) {
      if (err) {
        return cb(err);
      }
      master = parseXMLToObject(text);
      masterCache[masterID] = master;
      cb(null, master);
    });
  } else if (runtimeHelper.isLoadFromRemote() || runtimeHelper.isLoadFromMockplus()) {
    apiHelper.loadResource('app/Master/' + masterID + runtimeHelper.getMBXExtension() + '?v=' + version, function (err, text) {
      if (err) {
        return cb(err);
      }
      master = parseXMLToObject(text);
      masterCache[masterID] = master;
      cb(null, master);
    });
  } else {
    var node = document.getElementById(masterID);
    if (!node) {
      return cb(new Error('cannot find content of master:' + masterID));
    }
    var masterContent = node.innerHTML.trim();
    try {
      master = parseXMLToObject(masterContent);
      masterCache[masterID] = master;
      cb(null, master);
    } catch (e) {
      cb(e);
    }
  }
}

/**
 * 替换页面中所有母版组件
 * @param comArray 组件列表
 * @param cb 回调函数
 */
function doReplacePageMasterCom(comArray, cb) {
  var totalCount = 0;
  var needReplace;
  var callback;
  var updateChildVisible;

  if (comArray.length === 0) {
    return cb();
  }

  needReplace = _.filter(comArray, function (com) {
    return com.controlTypeID === 'Master' && com.items;
  });

  if (needReplace.length === 0) {
    return cb();
  }

  callback = _.after(totalCount, function () {
    cb();
  });

  updateChildVisible = function (items, isShow) {
    var com;
    var i;
    var l = 0;
    if (items) {
      l = items.length;
      for (i = 0; i < l; i++) {
        com = items[i];
        com.isShow = isShow;
        if (com.items) {
          updateChildVisible(com.items, isShow);
        }
      }
    }
  };

  _.each(needReplace, function (com) {
    if (com.controlTypeID === 'Master') {
      com.controlTypeID = '__group__';
      getMaster(com.masterID, function (err, masterData) {
        if (!err) {
          Reconstruction.reconstruction(masterData);

          com.items = masterData.master.controls.control[0].items;
          updateChildVisible(com.items, com.isShow);
          resetNewComID(com.items);
        }
        callback();
      });
    } else {
      doReplacePageMasterCom(com.items, function () {
        callback();
      });
    }
  });
}

// ---------------------------------------------------------------------------------------------------------------------

function doReplaceContentPanelComData(comRootArray, comSourceArray, pageIDStack, cb) {
  var i;
  var com;
  var links;
  var targetPageID;
  var link;

  if (!comSourceArray || comSourceArray.length === 0) {
    return cb();
  }

  var afterAll = _.after(comSourceArray.length, function () {
    cb();
  });

  function loadPageDone(err, pageData) {
    if (err) {
      return cb(err);
    }
    if (!pageData) {
      afterAll();
      return;
    }
    Reconstruction.reconstruction(pageData);
    if (!pageData.controls.control) { // 没有组件
      return afterAll();
    }
    // 首先替换页面数中的所有组件ID号，防止与其他页面中组件ID号冲突
    resetNewComID(pageData.controls.control);
    com.items = [];
    doMergeContentPanelComData(comRootArray, com.items, pageData.controls.control, pageIDStack, function (err) {
      if (err) {
        return cb(err);
      }
      //
      // 该页面加载完成，则从栈顶退出，能够保证不会出现循环加载情况，不退出则会造成不能第二次加载相同页面
      //
      //  如：
      //  A => B => C
      //  A => C
      //
      //  A页面包含B和C两个页面，B页面中包含C页面
      //
      //
      pageIDStack.pop();
      afterAll();
    });
  }

  for (i = 0; i < comSourceArray.length; i++) {
    com = comSourceArray[i];

    links = com.links;
    if (!links || !links.link) {
      afterAll();
      continue;
    }

    link = links.link[0];
    if ((link.linkType === appTypes.PageLinkType.INCLUDE_PAGE) && (link.isApplyIncludePage)) {
      targetPageID = link.targetPageID;
      if (!targetPageID || pageIDStack.indexOf(targetPageID) !== -1) {
        afterAll();
        continue;
      }

      // 把当前页面加入到栈队列中
      pageIDStack.push(targetPageID);

      loadPage(targetPageID, loadPageDone);
    } else {
      // 遍历子合并子节点
      if (com.items) {
        doReplaceContentPanelComData(comRootArray, com.items, pageIDStack, afterAll);
      } else {
        afterAll();
      }
    }
  }

}

/**
 * 合并组建内容数据资源
 * @param comRootArray 带插入的root节点Array
 * @param comInsertArray 当前带插入的节点的Array
 * @param comSourceArray 组件列表数据
 * @param pageIDStack 页面ID内容栈
 */
function doMergeContentPanelComData(comRootArray, comInsertArray, comSourceArray, pageIDStack, cb) {

  var comList = [];
  var com;
  var i;

  for (i = 0; i < comSourceArray.length; i++) {
    com = comSourceArray[i];
    comList.push(com);

    if (pageHelper.IsInvisualInteractiveCom(com.controlTypeID)) {
      comRootArray.push(com);
    } else {
      comInsertArray.push(com);
    }
  }

  doReplaceContentPanelComData(comRootArray, comList, pageIDStack, function (err) {
    if (err) {
      return console.error(err);
    }
    cb();
  });
}

/**
 * 合并生成预览数据，替换组件ID号，合并内容面板数据。
 *
 * @param comArray 根节点control对象
 */
function mergeContentPanelComData(comArray, cb) {
  var pageIDStack = [];
  var comRootArray = [];

  // 第一层节点中，rootArray和InsertArray为同一个。
  doMergeContentPanelComData(comRootArray, comRootArray, comArray, pageIDStack, function (err) {
    if (err) {
      return cb(err);
    }
    cb(null, comRootArray);
  });
}

// ---------------------------------------------------------------------------------------------------------------------

/**
 * 替换页面中的所有母版资源
 * @param pageData
 */
function getRealPageComData(pageData, cb) {
  var controlsNode = pageData.mockup.controls;
  if (!controlsNode.control) {
    return cb();
  }
  // 重新生成组件数据对象
  mergeContentPanelComData(controlsNode.control, function (err, comRootArray) {
    if (err) {
      return cb(err);
    }
    controlsNode.control = comRootArray;
    // 替换页面中母版组件数据
    doReplacePageMasterCom(controlsNode.control, function (err) {
      if (err) {
        return cb(err);
      }
      // 重新生成所有组件中组件ID号
      resetNewComID(controlsNode.control);
      cb();
    });
  });
}

function parseXMLToPage(text, id, cb) {
  var page;
  var obj = parseXMLToObject(text);
  Reconstruction.reconstruction(obj);

  return getRealPageComData(obj, function (err) {
    if (err) {
      return cb(err);
    }

    page = obj.mockup;
    page.ID = id; // 有时候页面内的 ID 不是页面的真实 ID

    page.title = getPageTitleByPageID(currentProject.modules, id);
    page = pageHelper.afterLoadPrepareDataStructure(page);
    pagesCache[id] = JSON.parse(JSON.stringify(page)); // 保存副本
    cb(null, page);
  });
}

/**
 * 加载页面数据
 * @param id
 * @param cb
 * @returns {*}
 */
function loadPage(id, cb) {
  if (id === 'command:back') {
    return cb(null);
  }
  var page;
  var node;
  var xml;
  if (pagesCache[id]) {
    return cb(null, JSON.parse(JSON.stringify(pagesCache[id]))); // 克隆一份使用
  }

  if (runtimeHelper.isLoadFromRemote() || runtimeHelper.isLoadFromMockplus()) {
    apiHelper.loadResource('app/MBX/' + id + runtimeHelper.getMBXExtension() + '?v=' + version, function (err, text) {
      if (err) {
        return cb(err);
      }
      parseXMLToPage(text, id, cb);
    });
  } else if (runtimeHelper.isLoadFromEnterprise()) {
    apiHelper.loadResource('MBX/' + id + runtimeHelper.getMBXExtension() + '?v=' + version, function (err, text) {
      if (err) {
        return cb(err);
      }
      parseXMLToPage(text, id, cb);
    });
  } else if (runtimeHelper.isLoadFromZip()) {
    setTimeout(function () { // 用于模拟线上异步加载的, 不要去掉
      try {
        xml = zip.files['MBX/' + id + '.mbx'].asText().trim();
        parseXMLToPage(xml, id, cb);
      } catch (e) {
        console.error('fail to load page', id);
        cb(e);
      }
    }, 100);
  } else {
    node = document.getElementById(id);
    if (!node) {
      return cb(new Error('cannot find content of page:' + id));
    }
    xml = node.innerHTML.trim();
    parseXMLToPage(xml, id, cb);
  }
}

/**
 * 载入单个页面文件
 * @param id
 * @param cb
 */
exports.loadPage = loadPage;

/**
 * 载入图片
 * @param name
 * @returns {*}
 */
exports.loadImage = function (name) {
  var file;
  if (imageCache[name]) {
    return imageCache[name];
  }
  if (runtimeHelper.isLoadFromZip()) {
    try {
      file = zip.files['0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name];
      if (file) {
        imageCache[name] = URL.createObjectURL(new Blob([file.asArrayBuffer()], {type: 'image/png'}));
        return imageCache[name];
      }
      console.warn('image', name, 'not exists');
    } catch (e) {
      console.error(e);
    }
    return null;
  }
  if (runtimeHelper.isLoadFromEnterprise()) {
    imageCache[name] = '0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
    return '0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
  }
  imageCache[name] = currentPath + '/0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
  return currentPath + '/0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
};

exports.loadSVG = function (name) {
  var file;
  if (!name) {
    return;
  }
  if (imageCache[name]) {
    return imageCache[name];
  }
  if (runtimeHelper.isLoadFromZip()) {
    try {
      file = zip.files['0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name];
      if (file) {
        imageCache[name] = URL.createObjectURL(new Blob([file.asArrayBuffer()], {type: 'image/svg+xml'}));
        return imageCache[name];
      }
      console.warn('svg', name, 'not exists');
    } catch (e) {
      console.error(e);
    }
    return null;
  }
  if (runtimeHelper.isLoadFromEnterprise()) {
    imageCache[name] = '0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
    return '0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
  }
  imageCache[name] = currentPath + '/0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
  return currentPath + '/0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
};
/**
 * 根据页面ID号获取页面标题
 * @param modules 所有页面Module数据信息
 * @param ID 页面ID号
 * @returns 返回页面标题
 */
function getPageTitleByPageID(modules, ID) {
  var i;
  var node;

  for (i = 0; i < modules._pages.length; i++) {
    node = modules._pages[i];
    if (node.ID === ID) {
      return node.name;
    }

    if (node._pages && node._pages.length) {
      var pageTitle = getPageTitleByPageID(node, ID);
      if (pageTitle !== undefined) {
        return pageTitle;
      }
    }
  }
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

function getGoToPage() {
  var search = window.location.search;
  var searches = search.split(/[?@]/g);
  for (var i = 0; i < searches.length; i++) {
    var item = searches[i];
    if (item.startsWith('to=')) {
      return item.substring(3);
    }
  }
  return '';
}

function doGetAppFirstPage(module) {
  var i;
  var _page;
  var l;
  var rsPage;

  if (!module._pages) {
    return;
  }
  for (i = 0, l = module._pages.length; i < l; i++) {
    _page = module._pages[i];
    if (!_page.isModule) {
      return _page;
    } else {
      rsPage = doGetAppFirstPage(_page);
      if (rsPage) {
        return rsPage;
      }
    }
  }
}

/**
 * 获取项目第一个页面数据对象
 * @param modules
 */
function getAppFirstPage(modules) {
  return doGetAppFirstPage(modules);
}

/**
 * 获取第一个加载的页面ID
 * @returns {*}
 */
exports.getAppFirstPage = function () {
  var goToPage = urlHelper.getQueryString('to');
  if (goToPage) {
    return goToPage;
  }
  firstPageCache = firstPageCache || getAppFirstPage(currentProject.modules);
  return firstPageCache && firstPageCache.ID;
};

/**
 * 将 XML 文本转换为对象
 * @type {parseXMLToObject}
 */
exports.parseXMLToObject = parseXMLToObject;

function parseXMLToApp(text, cb) {
  var obj = parseXMLToObject(text);
  if (obj && obj.html && obj.html.body && obj.html.body.parsererror && obj.html.body.parsererror.div) {
    return cb(new Error(obj.html.body.parsererror.div));
  }
  if (obj.project.parsererror) {
    return cb(new Error(obj.project.parsererror.div));
  }
  if (obj.project.pages) {
    obj.project.modules = obj.project.pages;
  }
  normalizeAppDataAndCache(obj);
  cb(null, obj.project);
}

/**
 * 载入项目文件
 * @param path 项目文件路径
 * @param cb
 */
exports.loadApp = function (path, cb) {
  var html;
  // 加载项目时清理 cache
  masterCache = {};
  pagesCache = {};
  firstPageCache = null;

  if (runtimeHelper.isLoadFromZip()) {
    JSZipUtils.getBinaryContent(path + '?v=' + Math.random(), function (err, data) {
      if (err) {
        cb(err);
        return;
      }
      zip = new JSZip(data);
      html = zip.files['Main.mpk'].asText().trim();
      parseXMLToApp(html, cb);
    });
  }
  else if (runtimeHelper.isLoadFromEnterprise()) {
    apiHelper.loadResource('Main' + runtimeHelper.getMPKExtension() + '?v=' + version, function (err, text, statusCode) {
      if (err) {
        console.error(err);
        cb(err, null, statusCode);
        return;
      }
      parseXMLToApp(text, cb);
    });
  } else if (runtimeHelper.isLoadFromRemote() || runtimeHelper.isLoadFromMockplus()) {
    apiHelper.loadResource('app/Main' + runtimeHelper.getMPKExtension() + '?v=' + version, function (err, text, statusCode) {
      if (err) {
        console.error(err);
        cb(err, null, statusCode);
        return;
      }
      parseXMLToApp(text, cb);
    });
  } else {
    var node = document.getElementById('main');
    if (!node) {
      return cb(new Error('cannot find content of app'));
    }
    html = node.innerHTML.trim();
    parseXMLToApp(html, cb);
  }
};

/**
 * 处理 app 数据
 */
function normalizeAppDataAndCache(obj) {
  currentProject = obj.project; // cache current project;
  countChildPages(obj.project.modules);
  obj.project.modules.isModule = true;
  obj.project.modules.childCount = countANode(obj.project.modules);
}

function countANode(node) {
  if (node.childCount) {
    return node.childCount;
  }
  if (node._pages) {
    var childCount = _.reduce(node._pages, function (memo, item) {
      return memo + countANode(item);
    }, 0);
    return node.isModule ? childCount : childCount + 1;
  }
  return node.isModule ? 0 : 1;
}

function countChildPages(node) {
  _.each(node._pages, function (item) {
    item.childCount = countANode(item);
    countChildPages(item);
  });
}

exports.auth = function (pwd, cb) {
  request.post('/auth')
    .send("id=" + getAppID())
    .send("password=" + pwd)
    .end(function (err, res) {
      cb(err, res);
    });
};


function getAppID() {
  var re = /\/([^\/]+)\/index.html/i;
  var match = re.exec(window.location.href);
  if (match) {
    return match[1];
  }
  return '';
}



// WEBPACK FOOTER //
// ./src/helper/projectLoadHelper.js